var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.36 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b1b4c4;}.cls-2{fill:#616e84;}.cls-3{fill:#20232d;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#2b303f;}.cls-14,.cls-6{opacity:0.1;}.cls-7{fill:#757b89;}.cls-8{fill:#e9eaf2;}.cls-9{fill:#ced0db;}.cls-10{fill:#2b2a30;}.cls-11{fill:#ffcea9;}.cls-12{fill:#f4f4f4;}.cls-13{fill:#2f55d4;}.cls-15,.cls-21{fill:#d6d8e5;}.cls-15{opacity:0.4;}.cls-16{fill:#ededed;}.cls-17{fill:#1d3892;}.cls-18{fill:#2f55d4;}.cls-19{fill:#2f55d4;}.cls-20{fill:#1d3892;}.cls-22{fill:#e4e6ef;}.cls-23{fill:#28221c;}.cls-24{fill:#99b524;}.cls-25{fill:#a6ce28;}.cls-26{fill:#d9dce8;}.cls-27{fill:#eff1f9;}.cls-28{fill:#d3d6e2;}.cls-29{fill:#c5c8d3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Telemedicine_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.51,409.33,310.63,347c-9.14-5.27-16.55-19.43-16.55-31.61V14.49c0-12.18,7.41-17.78,16.55-12.5L418.51,64.27c9.14,5.28,16.55,19.44,16.55,31.62V396.82C435.06,409,427.65,414.61,418.51,409.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "420.36 414.76 428.91 410.44 420.71 396.38 420.36 414.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "292.4 4.99 300.27 0.86 298.68 12.46 292.4 4.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.63,412.77,303.75,350.48c-9.14-5.27-16.55-19.43-16.55-31.61V17.93c0-12.18,7.41-17.78,16.55-12.51L411.63,67.71c9.14,5.28,16.55,19.43,16.55,31.62V400.26C428.18,412.45,420.77,418.05,411.63,412.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M427,100.1V401c0,12.2-7.4,17.79-16.54,12.52l-42.31-24.43L355,381.52,302.6,351.25c-9.14-5.28-16.54-19.43-16.54-31.62V18.7c0-12.19,7.4-17.78,16.54-12.51L410.49,68.47C419.63,73.76,427,87.9,427,100.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419.25,97v293.1c0,7.37-5.17,10.38-11.57,6.68L374,377.35l-3-1.72-1-.59-7.29-4.2-21.1-12.17h0l-8.75-5.05-3.52-2-23.91-13.8c-6.39-3.69-11.57-12.67-11.57-20.07V24.63c0-7.39,5.18-10.38,11.57-6.69l42.12,24.32v.12c0,5.75,4,12.74,9,15.61s9,.54,9-5.2c0,0,0-.09,0-.13L407.68,77C414.08,80.67,419.25,89.65,419.25,97Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 356.55,
    cy: 50.77,
    rx: 2.79,
    ry: 4.84,
    transform: "translate(22.39 185.08) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M356.55,52.43a3.16,3.16,0,0,1-1.44-2.49c0-.91.64-1.28,1.44-.82A3.16,3.16,0,0,1,358,51.6C358,52.51,357.34,52.88,356.55,52.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M431.41,139.69h0c-.88.51-1.59,0-1.59-1.2V125.66a3.82,3.82,0,0,1,1.59-3h0c.88-.51,1.59,0,1.59,1.21v12.83A3.81,3.81,0,0,1,431.41,139.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M431.41,160.72h0c-.88.5-1.59,0-1.59-1.21V146.68a3.83,3.83,0,0,1,1.59-3.05h0c.88-.5,1.59,0,1.59,1.21v12.83A3.83,3.83,0,0,1,431.41,160.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M399,371.8l-84.85-49c-4.4-2.54-8-9.37-8-15.24V150c0-5.88,3.58-8.58,8-6l84.85,49c4.41,2.55,8,9.37,8,15.25v157.6C407,371.64,403.38,374.34,399,371.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 335.56,
    cy: 192.78,
    rx: 13.03,
    ry: 22.57,
    transform: "translate(-51.43 193.62) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "394 224.41 361.18 205.46 361.18 197.78 394 216.73 394 224.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "386.43 233.85 361.18 219.28 361.18 211.6 386.43 226.18 386.43 233.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "394 268.74 319.61 225.79 319.61 218.12 394 261.06 394 268.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "376.83 272.65 319.61 239.61 319.61 231.93 376.83 264.97 376.83 272.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "393.74 296.23 319.35 253.28 319.35 245.6 393.74 288.55 393.74 296.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "376.58 300.14 319.35 267.1 319.35 259.42 376.58 292.46 376.58 300.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "393.74 323.87 319.35 280.92 319.35 273.24 393.74 316.19 393.74 323.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "393.08 351.12 318.69 308.17 318.69 300.5 393.08 343.44 393.08 351.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "376.58 327.78 319.35 294.74 319.35 287.06 376.58 320.1 376.58 327.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M329.61,135.35l0,0a2.93,2.93,0,0,1-1.27-2.09L323,70.78l-4.2,26.81c-.1.67-.65.89-1.29.52l-10.21-5.9A2.9,2.9,0,0,1,306,89.94c0-.83.59-1.17,1.31-.76l9.1,5.26L322,58.6c.1-.68.69-.89,1.33-.49a3,3,0,0,1,1.26,2.08l5.24,61.56,5-36.86c.09-.68.62-.91,1.25-.57a2.92,2.92,0,0,1,1.32,2l6,35.93,5.84-47c.08-.7.64-.94,1.29-.57h0a2.89,2.89,0,0,1,1.3,2l6.94,60.92,5.76-30c.12-.62.64-.82,1.26-.49l0,0a3,3,0,0,1,1.27,1.88l5.86,30.2,5.25-45.46c.08-.69.62-.95,1.27-.59a2.83,2.83,0,0,1,1.32,2l6.45,48,4.52-21c.12-.6.62-.8,1.21-.49a2.88,2.88,0,0,1,1.31,1.8l4.36,17.93,9.37,5.26h0a2.88,2.88,0,0,1,1.31,2.25c0,.84-.56,1.19-1.29.79l-10.33-5.8h0a3,3,0,0,1-1.25-1.77l-3.17-13-4.93,23c-.13.63-.68.84-1.31.43a2.92,2.92,0,0,1-1.26-2l-6.09-45.27-5,43.35c-.08.67-.59.93-1.22.61a2.85,2.85,0,0,1-1.35-1.92L366,115.66l-6.14,31.91c-.13.65-.7.83-1.33.45a3,3,0,0,1-1.26-2l-6.67-58.66L345,132.19c-.08.68-.61.93-1.25.59a3,3,0,0,1-1.33-2l-6-36.26-5.5,40.25C330.81,135.49,330.26,135.72,329.61,135.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-10",
    d: "M344.14,101.42c2.09-3.36,18.07-5.57,23.32,8,2,5.13,1.69,18.25,3.36,26.5s5.59,12.91,7,19.6-.89,17.89-17,19.87-28.51-3.67-32.31-8.81-3.89-16.06.07-21.92,6.95-10.64,6.86-18.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-10",
    d: "M354.69,99.09s-12-3.47-19.32,3c-6.67,5.94-6.11,14-5.14,17.83s2.91,9,5.93,9.27S354.69,99.09,354.69,99.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-11",
    d: "M359.29,131.89s-.79,13.41-.55,14.39,5.27,1.94,6.67,3.11-7.29,14.77-11.71,16.79-18.12-3.13-19.07-10c-.87-6.27,3.92-11.14,5.77-12.84a27.21,27.21,0,0,1,3.78-.1l.4-6.5C350.58,134.88,359.29,131.89,359.29,131.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M326.87,157.22c-.08-.37-2,.71-2.05.74s-.95,34.4-2.65,37.51h0c-4.28,7.31-15.66,19.66-15.94,21.05-.84,4.17,1.58.43,5.49,0,2.2-.27,15.11-13.34,18-16.32l.18.11c0-.12,0-.23.05-.34l.38-.39a17.16,17.16,0,0,0,.09-2.78C335.79,159.43,329.19,156.94,326.87,157.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.94,162.5l-.68,16.56-1.09,13.05s.21,1.75-1.71,4.81-12.18,15.77-12.18,15.77l4.64,3.85,10.57-8.68,7-46.76-3.68-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M361.13,147.59c3.76.58,8.07,2.59,8.66,4.65.69,2.41,2.18,13.75-1.08,22.38s-5.46,14.12-7.33,17.83c0,0-16.3,7-29.44-1.16,0,0-.9-9.24-1-14.19-12.13-10.58-1.76-23.63,8.51-33.76a20.85,20.85,0,0,1,3.7-.05s-9.16,10.84-2.79,17C354.05,156.16,356.76,150,361.13,147.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-11",
    d: "M334.24,115.28h0c1.36-8.61,7.58-15.12,16.46-14.6a17.07,17.07,0,0,1,8.59,31.21,17.47,17.47,0,0,1-1.37,3.77c-3.15,3.66-11.51,6-14.27,6-2.38,0-4.44-2.2-6.67-5.9C332.32,128.08,333.5,119.54,334.24,115.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M353.45,100.84c6.23,1.22,11.36,3,13.05,9.09,1.16,4.21,2.67,12.25,1.23,15.63l-.9,2.44-7.54,3.89s-3.52-2.93-2.43-11.53a6.1,6.1,0,0,0-1.06-3.26,10,10,0,0,1-1-2.6c-.76-2.4-2.69-4-4.89-5.29-5.62-3.15-13.84-.43-15,.71C338.67,102.14,346.21,99.42,353.45,100.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M375.56,237.18c-1,10.88-7.06,57.12-7.06,57.12a86,86,0,0,1,3.74,24c-.06,6.73-1.82,18.15-3.81,28.73l-3.49,25.15-8.33-4.82.33-18.75c-.43-6.28-1.05-15.55-1.45-21.48-.65-9.64-2.38-25-2.88-28.78s-1.72-10.5-2.31-18-3.41-45.55-3.41-45.55l-.39,7.13s-.37,11.58-2,25.84-2.26,20.62-2.26,20.62,2.89,5.3,3.26,9.21c.3,3.09,3.82,27.49,1.71,39.91l-3.09,22.62-10-5.74-1.29-16.15c-1.71-12.1-5.32-37.76-5.88-41.1-.72-4.39-1.32-6.55-2.16-20.35s-.53-43.77.86-54.64,5.4-26.66,5.4-26.66a32,32,0,0,0,12.06,3c7,.36,18.25-1.77,18.25-1.77a110,110,0,0,0,6.43,9.95C370.94,211,377,220.53,375.56,237.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M361.38,192.45l9.36,18.81s14.29,20.91-.52,74.67L373,302.51s-28,18-46.77,0c0,0-6.51-49.68-3.05-72.59A263.09,263.09,0,0,1,331.91,191s4.59,5.07,28.22,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.49,143.34s-13.86,2.26-15.55,19.16l3.17-3.17S334.88,147.57,339.49,143.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.19,143.29c-3.58,6.91-13,18.2-10.33,30.42,3.54,16.29-3.24,113.9-3.24,113.9s-8-5.07-8-9.13,3-109.42,3-114.41,8.76-13.85,14.71-20.77a13.79,13.79,0,0,1,4.91-.81c0,.37,0,.42-.05.8C343.89,143.31,343.72,143.29,343.19,143.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "281.42 232.72 313.42 214.12 336.4 227.39 304.39 245.99 281.42 232.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M309.29,215.48c-2,.46-4,.61-5.68,1.86a13.68,13.68,0,0,1-2,1.48c-.32.17-.63.37-1,.51a3.1,3.1,0,0,0-1.28.85,3.16,3.16,0,0,0-.57,1.77,7.53,7.53,0,0,0-.11,2.32c.28,1.15,1.47,1.06,2.1.26a2.46,2.46,0,0,0,.53-1.4,3.08,3.08,0,0,1,1.35-2.45l7.65-4.75A.93.93,0,0,0,309.29,215.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.47,173.06s-.26,28.71.79,38,14.3,36.51,2.63,73.44c-1.72,2-3.3,6.05-18,7.75-8.77,0-11.95-1.34-11.95-1.34s3.39-61.93-1.53-116.31c0-15,12.9-13.26,15.29-29.88,11.39,5.32,11.4,7,11.4,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M365.69,151.4c-6.27.7-7.09,8.65-7.09,8.65l-.29,12.17s.68,15.52,2.48,20.25l-27.2,18.69,5.93,6.91s28.74-13.27,31-15.37,0-26.45.35-33.46C372.38,156,372,150.7,365.69,151.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M370.19,158.13c-1.06-4.35-4.47-2.95-7.4-5.5-6.81,9.63-2.29,35.68-1.37,38.46L335.3,207.74h0c-.42.28-1.32.83-1.75,1.1-2.37,1.43-6.93,3.91-9.71,4.23-2.62.3-4,4-6.78,4.31a1.08,1.08,0,0,0-.71,1.86c1.12,1.08,4.11.19,6.15-2.2a1,1,0,0,0,0,.18,2,2,0,0,0,1.64,2,.94.94,0,0,0,.14.49,2,2,0,0,0,1.56,1.13h0a2,2,0,0,0,2.15,1.39,2.37,2.37,0,0,0,1.57-.72,13.81,13.81,0,0,0,5.71-4.12,57,57,0,0,1,4.24-3.94c7.09-3.05,28.35-12.13,29.3-13.42C370.19,198.12,371.7,164.34,370.19,158.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.64,149.3c-6.27.7-7.09,8.65-7.09,8.65l-.29,12.16s.68,15.53,2.47,20.26l-27.19,18.69,5.93,6.91s28.74-13.27,30.95-15.37,2.77-23.74,3.15-30.74C374.13,156.64,370.92,148.6,364.64,149.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 169.8,
    cy: 450.86,
    rx: 49.46,
    ry: 28.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-11",
    d: "M134.56,239.1c-.55,4.81-6.29,25.56-5.06,32.67s20.84,19,20.84,19l2.72-12.17L142.2,268l2.93-20.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-16",
    d: "M149.73,218.65c-2.8-1.21-8-1.48-10.92,3.3s-5.88,21.16-6.15,24c0,0,4.05,5.59,10.12,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M172.12,450a16.84,16.84,0,0,0,12.69-1.54c3.05.09,19.64-7,21.9-1.05,2,5.23-5.21,10.06-9.05,11-8.38,2-14.58,6.21-17.95,6.92-2.5.53-5.75.88-7.75-1.09C169.57,461.88,169.77,453.13,172.12,450Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179.71,463.89c3.37-.7,9.57-4.88,17.95-6.91,3.22-.78,8.76-4.3,9.32-8.5.74,4.81-5.74,9.08-9.32,9.94-8.38,2-14.58,6.21-17.95,6.92-2.5.53-5.75.88-7.75-1.09a5,5,0,0,1-1.1-2C173.78,464.67,177.21,464.42,179.71,463.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M145.21,437.93a16.78,16.78,0,0,0,12.69-1.53c3.06.09,19.64-7,21.9-1,2,5.23-5.21,10.06-9.05,11-8.38,2-14.58,6.21-17.94,6.92-2.51.53-5.76.88-7.75-1.1C142.66,449.8,142.87,441.05,145.21,437.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M152.81,451.81c3.36-.71,9.56-4.88,17.94-6.91,3.22-.78,8.76-4.31,9.32-8.5.75,4.81-5.74,9.08-9.32,9.94-8.38,2-14.58,6.21-17.94,6.92-2.51.53-5.76.88-7.75-1.1a4.76,4.76,0,0,1-1.1-2C146.87,452.58,150.3,452.34,152.81,451.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-19",
    d: "M144.88,392.86a101.35,101.35,0,0,1,3.83-18.17S147.57,359,147,344.14c-.65-16.87-6.5-31.72-1.89-45.18l52.06,11.58s-3.15,67.26-3.85,75.4A151.22,151.22,0,0,1,191,404.82c-2.38,13.06-6.24,44.12-6.24,44.12-5.51,3.2-12.73,1.43-12.73,1.43s.4-39.28.75-48.69c.43-11.49.78-10.61.78-10.61l-1.72-28.61-1.12-14.24s-1.44,10.45-2.38,19.78c-.82,8.14-2.78,15.5-5,30.64-1.9,13.14-5,39.54-5,39.54-5.5,3.2-13,.55-13,.55S143.39,404.26,144.88,392.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-11",
    d: "M152.48,218.93c4,.2,6.92,1.22,7.42,0a52.39,52.39,0,0,0,.9-6.2c-.46-1.15-.85-2.38-.85-2.38-5-3.07-6.55-8.45-7.21-14.71-1.11-10.71,4.67-20.09,15.38-21.21,10.07-1,17.48,6,19.45,15.75,1.07,4.79,3.19,13.86.32,21.75-1.6,4.41-3.66,7.91-5.73,8.59a51.23,51.23,0,0,1-5.95-.52h0s-.53,3-.9,4.88-.22,2.92,3.58,5.27-5.75,7.15-12,6.68-13.25-4.24-15.18-8.28C149.58,224.1,149.76,218.8,152.48,218.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M158.22,219.52c-1.1,2.74,1.69,6.09,9.14,8.43s8.11-.67,8.11-.67,10.92,5,14.47,7.45c4.47,3.13,6.45,12.17,7.06,27.43.69,17.66.75,43.86.17,48.38,0,0-8.35,8.32-19,7.44s-28.67-10.33-33-17.64c.12-15.48,1.93-18-.58-26.92-5.74-20.42-8.76-28.78-6-42.35,2.3-11.19,5.52-12.58,9.94-12.47A92,92,0,0,1,158.22,219.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-11",
    d: "M213.8,276.76c-8.77,2.21-10.83-3.32-12-7.9-2.79-11.09-4.29-21.1-6.37-27.39-2.45-7.42-5-8.61-8.62-10.05-4.24-1.7-7.88,1.88-6.47,11.32,1.67,11.18,3.86,19,8,32.25,1.09,3.45,3.53,9.59,7.2,12.55,4.52,3.66,11.34,3.5,21.65.94,4.4-1.1,9.22-3.73,17.54-7.61,2.23-1,4-1.73,8.25-3.73s8.75-5.33,11-8.58,2.54-4.78,2.08-5.52c-.57-.93-1.59-.73-2.79.64a23.8,23.8,0,0,1-6.31,5.84s2.77-2.86,4.27-4.72a23.58,23.58,0,0,0,3.32-5.42c.79-1.9-.84-4.47-2.08-3.12s-1.83,2.73-4.1,5.45a23.73,23.73,0,0,1-4.07,3.87,44.57,44.57,0,0,0,3.75-6c1.44-2.94,1.42-4.45,1.36-5.44s-1.46-2.17-2.77-.3c-1.19,1.69-2,4.33-4.71,7.2-2,2.08-3.71,3.28-3.76,2.7s1.21-1.72,1.93-4.14,0-5-1.34-5.26-1.08-.2-2.16,2.06-2.72,3.94-4,7.25c-1.11,2.91-1.61,4.09-3.61,6.21C226.9,272.12,222.14,274.66,213.8,276.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-16",
    d: "M183.57,229.9c5.86-.86,10,1.78,12.58,10.65s4.4,16.16,4.4,16.16a15.94,15.94,0,0,1-9.81,6.51c-7,1.7-9.53-1.65-9.53-1.65s-2-9.3-3.16-15.63S176.32,231,183.57,229.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M187.23,188.81s9.26-14.07-10.79-16.94c-14.46-2.06-23.76,7.23-24.83,17.31-1,9.63,4.91,19.63,9.19,23.6,2.09.75,6.59,1.18,12.5-1.51a70.89,70.89,0,0,0,.27-7.89S166.52,188.55,187.23,188.81Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 54.58,
    cy: 348.37,
    rx: 23.98,
    ry: 13.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 58,
    cy: 345.8,
    rx: 23.98,
    ry: 13.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "25.9 298.46 34.29 346.76 81.92 346.76 90.11 298.81 25.9 298.46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 58,
    cy: 297.86,
    rx: 32.13,
    ry: 18.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58,312.32c-7.87,0-15.21-1.73-20.67-4.88-4.68-2.71-7.37-6.2-7.37-9.58s2.69-6.87,7.37-9.57c5.45-3.15,12.8-4.89,20.67-4.89s15.22,1.74,20.68,4.89c4.68,2.7,7.36,6.19,7.36,9.57s-2.68,6.87-7.36,9.58C73.22,310.59,65.88,312.32,58,312.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M71.83,283.25s-.63-39.16-13.83-53c-16.11,14.18-13.56,53.06-13.56,53.06l13.76,25v0C60,308.37,71.83,283.25,71.83,283.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M58.2,308.28s-7.33-46.92-34.57-64.55C23.63,243.73,18.77,308,58.2,308.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M58,308.28s6.61-46,33.16-62.6C91.16,245.68,97.43,308,58,308.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 342.45,
    cy: 486.17,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 346.01,
    cy: 485.28,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M322.06,485.06v-6.94l7.61,2.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "369.94 478.61 369.94 484.84 361.17 483.12 369.94 478.61"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 346.01,
    cy: 478.17,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "330.31 488.61 327.71 487.11 361.48 467.62 364.07 469.12 330.31 488.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "327.71 487.11 327.71 494.21 330.07 495.61 330.4 495.77 330.4 488.61 327.71 487.11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 23.95,
    cy: 461.12,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 27.51,
    cy: 460.23,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M3.56,460v-6.95l7.61,2.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "51.44 453.56 51.44 459.79 42.67 458.06 51.44 453.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 27.51,
    cy: 453.12,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "11.81 463.56 9.22 462.06 42.98 442.57 45.58 444.07 11.81 463.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "9.22 462.06 9.22 469.16 11.57 470.55 11.9 470.72 11.9 463.56 9.22 462.06"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 468.86,
    cy: 447.32,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 472.41,
    cy: 446.43,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M448.47,446.21c0-.06,0-6.95,0-6.95l7.62,2.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "496.35 439.76 496.35 445.99 487.58 444.26 496.35 439.76"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 472.41,
    cy: 439.32,
    rx: 23.95,
    ry: 13.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "456.72 449.76 454.12 448.26 487.88 428.77 490.48 430.27 456.72 449.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "454.12 448.26 454.12 455.36 456.48 456.75 456.81 456.92 456.81 449.76 454.12 448.26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.0c82d7e24e32a1a1f2cb9fe70a5b2c7a.svg";
export { ForwardRef as ReactComponent };